import { Grid } from '@mui/material'
import React, { ReactNode } from 'react'

interface IFormBody {
  children: ReactNode
}

const FormBody: React.FC<IFormBody> = ({ children }) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        margin: '0 !important',
        marginBottom: '1.5rem !important',
        width: '100%',
        maxHeight: '100%',
        overflow: 'overlay',
        padding: '0rem 0.25rem',

        '& .MuiGrid-item': {
          paddingRight: '1rem !important',
          paddingLeft: '0 !important',
        },
      }}
    >
      {children}
    </Grid>
  )
}

export default FormBody
